import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogContent } from "@mui/material";
import { closeBrModal } from "../../Store/Slices/brSlice"
import AddBr from "./AddBr";
import EditBr from "./EditBr";
import DeleteBr from "./DeleteBr";


const BrDialog = () => {
    const dispatch = useDispatch();
    const {modalStatus} = useSelector((state) => state.br);

    let content;
    let deleteView = false;

    const roles = sessionStorage.getItem("roles");

    const handleClose = (event,reason) => {
        if(reason !== 'backdropClick'){
            dispatch(closeBrModal());
        }
    };

    switch(modalStatus){
        case "add":
            content = roles?.split(",").includes("PRIV_ES_ADD_ROLE") ? <AddBr handleClose={handleClose} /> : null;
            break;
        case "edit":
            content = roles?.split(",").includes("PRIV_ES_EDIT_ROLE") ?  <EditBr handleClose={handleClose} /> : null;
            break;
        case "delete":
            deleteView  = true;
            content = roles?.split(",").includes("PRIV_ES_DELETE_ROLE") ? <DeleteBr handleClose={handleClose} /> : null;
            break;
        default:
            content = null;
    };

    return (
        <Dialog
            fullWidth={true}
            open={["add", "edit", "delete"].includes(modalStatus)}
            onClose={handleClose}
            aria-labelledby="coupon-dialog-title"
            aria-describedby="coupon-dialog-description"
            
        >
            <DialogContent>{content}</DialogContent>
        </Dialog>
    );
};

export default BrDialog;